import React from "react";

type IconChevronLeftProps = {
  color?: string;
  size?: number | string;
} & React.SVGProps<SVGSVGElement>;

const IconChevronLeft: React.FC<IconChevronLeftProps> = ({
  color,
  size,
  ...props
}) => (
  <svg
    width={size || 16}
    height={size || 16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.66485 12.6367L5.31427 8.33696C5.27073 8.29424 5.23614 8.24328 5.21253 8.18704C5.18892 8.1308 5.17676 8.07042 5.17676 8.00943C5.17676 7.94843 5.18892 7.88805 5.21253 7.83181C5.23614 7.77558 5.27073 7.72461 5.31427 7.6819L9.66485 3.38213C9.79299 3.25622 9.96545 3.18567 10.1451 3.18567C10.3247 3.18567 10.4972 3.25622 10.6253 3.38213C10.6882 3.44409 10.7382 3.51793 10.7722 3.59937C10.8063 3.6808 10.8239 3.7682 10.8239 3.85648C10.8239 3.94477 10.8063 4.03217 10.7722 4.1136C10.7382 4.19504 10.6882 4.26888 10.6253 4.33084L6.90344 8.00943L10.6253 11.6871C10.6882 11.7491 10.7381 11.823 10.7721 11.9045C10.8062 11.9859 10.8237 12.0734 10.8237 12.1617C10.8237 12.25 10.8062 12.3374 10.7721 12.4189C10.7381 12.5003 10.6882 12.5742 10.6253 12.6362C10.4972 12.7622 10.3247 12.8327 10.1451 12.8327C9.96545 12.8327 9.79299 12.7626 9.66485 12.6367Z"
      fill={color || "#131F6B"}
    />
  </svg>
);

export default IconChevronLeft;
